// extracted by mini-css-extract-plugin
export var text_black = "styles-module--text_black--e890a";